export default "__VITE_ASSET__dnc2Sgri__"